import { isNull, isUndefined } from 'lodash';
import debounce from 'lodash/debounce';
import SearchInput from '@/components/SearchInput';

function isDefined(value) {
  return !isNull(value) && !isUndefined(value);
}

export default (mixinOptions = {}) => {
  const useInternalSearch = mixinOptions.useInternalSearch || false;

  return {
    components: {
      SearchInput,
    },
    data() {
      return {
        internalSearch: null,
      };
    },
    methods: {
      resetInternalSearch() {
        this.internalSearch = null;
      },
    },
    computed: {
      searchQuery: {
        get() {
          if (useInternalSearch) return this.internalSearch;
          return this.$route.query.search;
        },
        set: debounce(function setSearch(search) {
          if (useInternalSearch) {
            if (isDefined(this.resetInternalPagination)) {
              this.resetInternalPagination();
            }
            this.internalSearch = search;
          } else {
            const query = { ...this.$route.query };

            if (search) {
              query.search = search;
            } else {
              delete query.search;
            }
            this.$router.replace({ query });
          }
        }, 500),
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/SearchableView.js